import { IUpdateMotivoAfastamentoUseCase } from "../../../presentation/useCases/update/update_motivo_afastamento_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * UpdateMotivoAfastamentoUseCase
 */

export class UpdateMotivoAfastamentoUseCase implements IUpdateMotivoAfastamentoUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async updateMotivoAfastamento(
    idMotivoAfastamento: number,
    ativo: number,
    descricaoMotivo: string,
  ): Promise<void> {
    await this.repository.updateMotivoAfastamento(
      idMotivoAfastamento,
      ativo === 1,
      descricaoMotivo,
    );
  }
}